module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "parttitle"
  }, [_vm._v("PART ONE")]), _vm._v(" "), _c('p', {
    staticClass: "parttitle"
  }, [_vm._v("The Paleo Way")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If man made it, don’t eat it.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphsource"
  }, [_vm._v("—Jack LaLanne")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f13660d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Part01.vue
// module id = 75
// module chunks = 0